import { FrontendVariables } from "@Front/Config/VariablesFront";

/**
 * Browser: `window.location.origin` (trimmed, no trailing slash). SSR: `FRONT_APP_HOST`.
 * Use for same-origin redirects (menu logout, logout-callback, IdNot redirect_uri / post_logout_redirect_uri)
 * so a wrong `NEXT_PUBLIC_FRONT_APP_HOST` or `public/config` from another product line cannot move the user
 * to another host while they stay on the current FQDN.
 */
export function resolveBrowserPublicFrontBaseUrl(): string {
	if (typeof window !== "undefined" && window.location?.origin) {
		return window.location.origin.replace(/\/$/, "");
	}
	return (FrontendVariables.getInstance().FRONT_APP_HOST ?? "").trim().replace(/\/+$/, "");
}

/**
 * Public origin for IdNot OAuth redirect_uri / post_logout_redirect_uri.
 * Delegates to {@link resolveBrowserPublicFrontBaseUrl}.
 */
export function resolveIdNotOAuthPublicBaseUrl(): string {
	return resolveBrowserPublicFrontBaseUrl();
}
